import { render } from "./HeroiconsOutlineSortDescending.vue?vue&type=template&id=347c92cf"
const script = {}

import exportComponent from "D:\\Programs\\Projects\\www\\cae-new-web\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineSortDescending.vue"]])

export default __exports__